import axios from 'axios'

const actions = {
    async createCodelab({ commit }, data) {
        const response = await axios.post(`${process.env.VUE_APP_NODE_API_HOST}/codelabs`, data.codelabData)

        return response.data.data
    },

    async updateCodelab({ commit }, data) {
        const response = await axios.put(`${process.env.VUE_APP_NODE_API_HOST}/codelabs/${data.id}`, data.codelabData)

        return response.data.data
    },

    async refreshCodelab({ commit }, id) {
        const response = await axios.post(`${process.env.VUE_APP_NODE_API_HOST}/codelabs/refresh/${id}`)
        return response.data.data
    },

    async refreshAll({ commit }, id) {
        const response = await axios.post(`${process.env.VUE_APP_NODE_API_HOST}/codelabs/project/${id}/refresh`)
        return response.data.data
    },

    async fetchCodelab({ commit }, id) {
        const response = await axios.get(`${process.env.VUE_APP_NODE_API_HOST}/codelabs/details/${id}`)
        return response.data.data
    }
}

export default {
    namespaced: true,
    actions,
}
